import { Button, Col, Flex, Row, Space, Table, Typography } from 'antd'
import React, { useEffect } from 'react'
import ZCard from '../../../../Card/Index'
import AmlAnalysisJson from '../../../../../utils/JsonData/amlAnalysis'
import { ExclamationCircleFilled, CheckCircleFilled } from '@ant-design/icons'
import BarChartWithMultipleDatasets from '../../../../Chart/BarChartWithMultipleDatasets'
import LineChart from '../../../../Chart/LineChart'
import PieChart from '../../../../Chart/PieChart'
import { useDispatch, useSelector } from 'react-redux'
import { getAmlAnalysisData } from '../../../../../api/amlAnalysis'
import { setAllAMLAnalysis } from '../../../../../store/reducers/slices/amlAnalysis.slice'
import { CURRENCY } from '../../../../../utils/ConstantData'
import { CurrencyFormatWithDecimal, CurrencyFormatWithoutDecimal } from '../../../../../helper/CurrencyFormate'
import { TabsEnum } from '../../../../../utils/Enum/ReportTabsEnum'
import { NumberFormat } from '../../../../../helper/NumberFormat'
import CardChip from '../../includes/CardChip'
import dayjs from 'dayjs'
import styles from "../reportTabs.module.scss"

const SuspiciousColumns = [
    { key: 1, title: "Activity", dataIndex: 'activity' },
    {
        key: 2, title: "Incidences", dataIndex: "incidences", align: "right",
        render: (value) => {
            if (value !== '0') {
                return <Space>{value} <ExclamationCircleFilled className="icon-error" style={{ fontSize: 20 }} /></Space>
            } else {
                return <Space>{value} <CheckCircleFilled className="icon-success" style={{ fontSize: 20 }} /></Space>
            }
        }
    }
]

const MonthlyMaxMinColumns = [
    { key: 1, title: "Month", dataIndex: "month" },
    {
        key: 2, title: `Maximum Balance(${CURRENCY})`, dataIndex: "maxBalance", align: "right",
        render: (value) => {
            return NumberFormat(
                value,
                true,
                CURRENCY
            ).replace(CURRENCY, '')
        }
    },
    {
        key: 3, title: `Minimum Balance(${CURRENCY})`, dataIndex: "minBalance", align: "right",
        render: (value) => {
            return NumberFormat(
                value,
                true,
                CURRENCY
            ).replace(CURRENCY, '')
        }
    },
    { key: 4, title: "Min to Max Balance %", dataIndex: "maxBalancePct", align: "right" },
    { key: 5, title: "Days Gap", dataIndex: "daysGap", align: "right" }
]

const AMLAnalysisReport = ({ onClickTabChange = () => { } }) => {
    const colors = ['#5C63D6', '#FF9101', '#FFD83D', '#2D582D', '#66bb6a'];
    const {
        isLoading,
        amlRiskIndicators,
        suspiciousActivities,
        monthlyWithdrawalsDeposits,
        top10DebitCounterparty,
        top10CreditCounterparty,
        monthlyMaxMinBalance,
        outflows,
        inflows,
        txnModeDistribution,
        monthlyTxns,
    } = useSelector(({ amlAnalysis }) => amlAnalysis);
    const { selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
    const dispatch = useDispatch();

    console.log("AML RISK INDICATOR::::", amlRiskIndicators);


    const Top10DeditCounterPartyColumn = [
        { key: 1, title: "Counterparty", dataIndex: 'counterparty', width: 150 },
        {
            key: 2, title: `Amount(${CURRENCY})`, dataIndex: 'amount', align: "right", className: 'no-wrap-column',
            render: (value) => (
                <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
            ),
        },
        {
            key: 3, title: "Amount%", dataIndex: 'amountPercentage', align: "right",
            render: (value, record, index) => {
                return `${value || ""} ${top10DebitCounterparty.length - 1 === index ? '' : '%'}`
            }
        },
        {
            key: 4, title: "Txn count", dataIndex: 'transactionCount', align: "right",
            render: (value, record, index) => {
                return (parseFloat(value) > 0 && top10CreditCounterparty.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
            }
        },
        {
            key: 5, title: "Txn %", dataIndex: "transactionPercentage", align: "right",
            render: (value, record, index) => {
                return `${value || ""} ${top10DebitCounterparty.length - 1 === index ? '' : '%'}`
            }
        }
    ]


    const Top10CreditCounterPartyColumn = [
        { key: 1, title: "Counterparty", dataIndex: 'counterparty', width: 150 },
        {
            key: 2, title: `Amount(${CURRENCY})`, dataIndex: 'amount', align: "right", className: 'no-wrap-column',
            render: (value) => (
                NumberFormat(
                    value || '0',
                    true,
                    CURRENCY
                ).replace(CURRENCY, '')
            ),
        },
        {
            key: 3, title: "Amount%", dataIndex: 'amountPercentage', align: "right",
            render: (value, record, index) => {
                return `${value || ""} ${top10CreditCounterparty.length - 1 === index ? '' : '%'}`
            }
        },
        {
            key: 4, title: "Txn count", dataIndex: 'transactionCount', align: "right",
            render: (value, record, index) => {
                return (parseFloat(value) > 0 && top10CreditCounterparty.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => onClickTabChange(TabsEnum.TRANSACTION)}>{value}</Button> : value
            }
        },
        {
            key: 5, title: "Txn %", dataIndex: "transactionPercentage", align: "right",
            render: (value, record, index) => {
                return `${value || ""} ${top10CreditCounterparty.length - 1 === index ? '' : '%'}`
            }
        }
    ]


    const onClickCommonRedirect = (value, tab) => {
        if (parseInt(value) > 0 && tab === 'CIRCULARTRANSACTION') {
            onClickTabChange(TabsEnum.CIRCULARTRANSACTION)
        } else if (parseInt(value) > 0 && tab === 'BOUNCEDCHEQUES') {
            onClickTabChange(TabsEnum.BOUNCEDCHEQUES)
        } else if (parseInt(value) > 0 && tab === 'TRANSACTION') {
            onClickTabChange(TabsEnum.TRANSACTION)
        }
    }


    useEffect(() => {
        const fetchData = () => {
            getAmlAnalysisData(selectedAccountId).then((resp) => {
                dispatch(setAllAMLAnalysis(resp));
            }).catch((error) => {
                console.log("aml error", error)
            })
        }
        if (selectedAccountId) {
            fetchData();
        }
    }, [selectedAccountId]);


    console.log("MONTHLY MIN MAX BALANCE>>>", monthlyMaxMinBalance, inflows, outflows);


    return (
        <>
            <Flex justify='space-between' style={{ marginBottom: "16px" }}>
                <CardChip className={styles.amlcardchip} label={`AML Risk Score`} value={amlRiskIndicators?.amlScore || "-"} />
                <CardChip className={styles.amlcardchip} label={`Daily Average Balance`} value={CurrencyFormatWithoutDecimal(Math.round(amlRiskIndicators?.monthlyAvgBalance) || '0', true, CURRENCY) || "-"} />
                <CardChip className={styles.amlcardchip} label={`Maximum Balance`} value={CurrencyFormatWithoutDecimal(Math.round(amlRiskIndicators?.maxBalance) || '0', true, CURRENCY) || "-"} />
                <CardChip className={styles.amlcardchip} label={`Minimum Balance`} value={CurrencyFormatWithoutDecimal(Math.round(amlRiskIndicators?.minBalance) || '0', true, CURRENCY) || 0} onClick={() => onClickCommonRedirect(amlRiskIndicators?.minBalance, 'CIRCULARTRANSACTION')} />
                <CardChip className={styles.amlcardchip} label={`Days Gap b/w Max & Min Balance`} value={amlRiskIndicators?.daysGap || 0} onClick={() => onClickCommonRedirect(amlRiskIndicators?.daysGap, 'BOUNCEDCHEQUES')} />
                <CardChip className={styles.amlcardchip} label={`Txn - ${(amlRiskIndicators.txnStartDate && amlRiskIndicators.txnEndDate)
                    ? `${dayjs(amlRiskIndicators.txnStartDate).format('DD/MM/YYYY')} -
            ${dayjs(amlRiskIndicators.txnEndDate).format('DD/MM/YYYY')}`
                    : ''}`} value={amlRiskIndicators?.txnCount || "-"} onClick={() => onClickCommonRedirect(amlRiskIndicators?.txnCount, 'TRANSACTION')} />
                <CardChip className={styles.amlcardchip} label={`MAX DORMANT DAYS - ${(amlRiskIndicators.dormatStartDate && amlRiskIndicators.dormatEndDate)
                    ? `${dayjs(amlRiskIndicators.dormatStartDate).format('DD/MM/YYYY')} -
            ${dayjs(amlRiskIndicators.dormatEndDate).format('DD/MM/YYYY')}`
                    : ''}`} value={amlRiskIndicators?.maxDaysDormant || "-"} onClick={() => onClickCommonRedirect(amlRiskIndicators?.maxDaysDormant, 'TRANSACTION')} />
            </Flex>

            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <ZCard.Title>Suspicious Activities</ZCard.Title>
                        <Table
                            columns={SuspiciousColumns}
                            dataSource={suspiciousActivities}
                            pagination={false}
                            loading={isLoading}
                        />
                    </ZCard>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <Flex className='pl-16 pb-20' justify='space-between'>
                            <ZCard.Title>Monthly Deposits & Withdrawals ({CURRENCY})</ZCard.Title>
                        </Flex>
                        <BarChartWithMultipleDatasets
                            dataArray={monthlyWithdrawalsDeposits}
                            xKey="month"
                            yKeys={['inflow', 'outflow']}
                            labels={['Deposits', 'Withdrawals']}
                            bgcolors={['rgba(88, 80, 236, 1)', 'rgba(242, 160, 8, 1)']}
                            borderColors={['rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)']}
                            horizontalLines={7} // Set the number of horizontal lines
                            yLableRoatation={30}
                            tooltipType="currency"
                            showlegendTitle={false}
                            showlegend={false}
                        />
                    </ZCard>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <ZCard.Title>Account Activity – Transaction Volume vs Overall Monthly Avg</ZCard.Title>
                        <LineChart
                            dataArray={monthlyTxns}
                            xKey="month"
                            yKeys={['avgTransactionCount', 'transactionCount']}
                            labels={['Overall Monthly Avg', 'Txn Count']}
                            bgcolors={['rgba(88, 80, 236, 1)', 'rgba(242, 160, 8, 1)']}
                            borderColors={['rgba(88, 80, 236, 1)', 'rgba(255, 159, 64, 1)']}
                            pointbgColors={['rgba(88, 80, 236, 1)', 'rgba(255, 159, 64, 1)']}
                            tooltipType="normal"
                            legendPosition="bottom"
                            showLegendTitle={false}
                            yLableRoatation={30}
                        />
                    </ZCard>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <ZCard.Title>Transaction Mode – Deposits & Withdrawals %</ZCard.Title>
                        <BarChartWithMultipleDatasets
                            dataArray={txnModeDistribution}
                            xKey="mode"
                            yKeys={['inflowPct', 'outflowPct']}
                            labels={['Deposits', 'Withdrawals']}
                            bgcolors={['rgba(88, 80, 236, 1)', 'rgba(242, 160, 8, 1)']}
                            borderColors={['rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)']}
                            horizontalLines={25} // Set the number of horizontal lines
                            tooltipType="percent"
                            showlegendTitle={false}
                            showlegend={false}

                        />
                    </ZCard>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <ZCard.Title>Top {outflows?.length} Uses - Outflow %</ZCard.Title>
                        <PieChart
                            dataArray={outflows}
                            labelKey="category"
                            valueKey="value"
                            bgcolors={colors}
                            cutout={'89%'}
                        />
                    </ZCard>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <ZCard.Title>Top {inflows?.length} Uses - Inflow %</ZCard.Title>
                        <PieChart
                            dataArray={inflows}
                            labelKey="category"
                            valueKey="value"
                            bgcolors={colors}
                            cutout={'89%'}
                        />
                    </ZCard>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <ZCard.Title>Top 7 Counterparties - Credit Transactions</ZCard.Title>
                        <Table
                            columns={Top10CreditCounterPartyColumn}
                            dataSource={top10CreditCounterparty}
                            pagination={false}
                            scroll={{ y: 350 }}
                            loading={isLoading}
                        />
                    </ZCard>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <ZCard.Title>Top 10 Counterparties - Debit Transactions</ZCard.Title>
                        <Table
                            columns={Top10DeditCounterPartyColumn}
                            dataSource={top10DebitCounterparty}
                            pagination={false}
                            scroll={{ y: 350 }}
                            loading={isLoading}
                        />
                    </ZCard>
                </Col>
                <Col xs={24} sm={24} md={24}>
                    <ZCard>
                        <ZCard.Title>Monthly Maximum & Minimum Balance</ZCard.Title>
                        <Table
                            columns={MonthlyMaxMinColumns}
                            dataSource={monthlyMaxMinBalance}
                            pagination={false}
                            loading={isLoading}
                            rowClassName={(record, index) => {
                                if (record.minBalance === "0" && (record?.maxBalancePct === "0" || record?.maxBalancePct === "0.00%") < 10) {
                                    return "table-cell-bg-error";
                                } else {
                                    return "bg-white";
                                }
                            }}
                        // rowHoverable={false}
                        // scroll={{ y: 350 }}
                        />
                    </ZCard>
                </Col>
            </Row>
        </>
    )
}

export default AMLAnalysisReport